import type { GetShopPaymentMethodsResponse } from '@fourthwall/services/dist/PaymentApiClient'

export const isPaymentMethodFailed = (
  paymentMethod: GetShopPaymentMethodsResponse['result'][number],
) =>
  paymentMethod.status === 'FAILED' ||
  (paymentMethod.details.type === 'CARD' && paymentMethod.details.expired)
